var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb-0 clickable d-flex flex-row align-items-start",
      class: { "ml-4": !_vm.noMargin },
      on: {
        click: function ($event) {
          return _vm.toggleEditing(true)
        },
        keydown: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.loading ? _c("inline-loader") : _vm._e(),
      _vm._v(" "),
      !_vm.editing
        ? _vm._t("title", function () {
            return [
              _c(
                "span",
                { class: [{ "pl-2": !_vm.noMargin }, _vm.textClass] },
                [_vm._v("\n      " + _vm._s(_vm.titleText) + "\n    ")]
              ),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editing
        ? [
            _c("material-input", { staticClass: "form-group-material" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.text,
                    expression: "text",
                    modifiers: { trim: true },
                  },
                ],
                ref: "textInput",
                staticClass:
                  "material-input form-control material-input-static-label form my-1 moregage-data",
                style: _vm.inputStyle,
                attrs: { type: "text", placeholder: _vm.placeholder },
                domProps: { value: _vm.text },
                on: {
                  blur: [
                    _vm.handleClickOutside,
                    function ($event) {
                      return _vm.$forceUpdate()
                    },
                  ],
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.handleClickOutside.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.text = $event.target.value.trim()
                  },
                },
              }),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }